<template>
  <img :src="src" :alt="alt" class="kb-image" :loading="loading">
</template>

<script>
/**
 * A wrapper for img-Tag.
 *
 * It is totaly fine to not use this component, and use a plain a tag instead.
 */
export default {
  name: 'kb-base-image',
  props: {
    src: {
      type: String,
      required: true
    },
    alt: String,
    loading: {
      type: String,
      default: 'auto'
    }
  }
}
</script>

